import gql from "graphql-tag";
import PublisherFragments from '@/graphql/PublisherFragments';

const PUBLISHER_DETAILS_FRAGMENT = PublisherFragments.publisherDetailsFragment;

export default {
  getPublishers: gql`
    query getPublishers($first: Int, $after: String, $name: String) {
      publishers(first: $first, after: $after, name: $name) {
        edges {
          node {
            ...PublisherDetails
          }
          cursor
        }
        pageInfo {
          hasNextPage
          endCursor
        }
        totalCount
      }
    }
    ${PUBLISHER_DETAILS_FRAGMENT}
  `,

  getPublisherSlug: gql`
    query getPublisherSlug($id: ID!) {
      publisher(id: $id) {
        id
        slug
      }
    }
  `,

  addPublisher: gql`
    mutation addPublisher(
      $name: String!
      $description: String
      $imageUrl: String
      $websiteUrl: String
      $twitterHandle: String
      $instagramHandle: String
      $tiktokHandle: String
      $facebookHandle: String
      $youtubeHandle: String
    ) {
      createPublisher(
        input: {
          name: $name
          description: $description
          imageUrl: $imageUrl
          websiteUrl: $websiteUrl
          twitterHandle: $twitterHandle
          instagramHandle: $instagramHandle
          tiktokHandle: $tiktokHandle
          facebookHandle: $facebookHandle
          youtubeHandle: $youtubeHandle
        }
      ) {
        publisher {
          ...PublisherDetails
        }
      }
    }
    ${PUBLISHER_DETAILS_FRAGMENT}
  `,

  updatePublisher: gql`
    mutation updatePublisher(
      $id: ID!
      $name: String
      $description: String
      $imageUrl: String
      $websiteUrl: String
      $twitterHandle: String
      $instagramHandle: String
      $tiktokHandle: String
      $facebookHandle: String
      $youtubeHandle: String
    ) {
      updatePublisher(
        input: {
          id: $id
          name: $name
          description: $description
          imageUrl: $imageUrl
          websiteUrl: $websiteUrl
          twitterHandle: $twitterHandle
          instagramHandle: $instagramHandle
          tiktokHandle: $tiktokHandle
          facebookHandle: $facebookHandle
          youtubeHandle: $youtubeHandle
        }
      ) {
        publisher {
          ...PublisherDetails
        }
      }
    }
    ${PUBLISHER_DETAILS_FRAGMENT}
  `,

  deletePublisher: gql`
    mutation deletePublisher($input: deletePublisherInput!) {
      deletePublisher(input: $input) {
        publisher {
          id
        }
      }
    }
  `,
};
